export function isDoubleQuotedString(char: string): boolean
{
  return char === '"'
}